import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ProblemListPage } from '@/features/AdminProblems/ProblemListPage';

export const Route = createFileRoute('/trainer/problems/')({
  component: TrainerProblemsPage,
});

function TrainerProblemsPage() {
  const navigate = useNavigate();
  return (
    <ProblemListPage
      onOpenProblem={id => navigate({ to: '/trainer/problems/$problemId', params: { problemId: id } })}
      onNewProblem={() => navigate({ to: '/trainer/problems/new' })}
      subtitle={total => `${total.toLocaleString()} ${total === 1 ? 'problem' : 'problems'} you authored`}
      emptyDescription="Problems you create appear here. The KodPrep problem bank stays available in the curriculum picker."
    />
  );
}
